// reactstrap components
import {
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Container,
  Media,
} from "reactstrap";
import React from "react";
import { formatDateTime } from "@/utils/formatDateTime";

/** The variable record the details modal shows (a row of the variables list). */
export type VariableDetailsRecord = {
  title: string;
  type: string;
  status?: string;
  variable_type?: string;
  variable_complex_type?: string;
  notes?: string;
  example?: string;
  image?: string;
  updatedAt?: string;
};

type VariableDetailsProps = {
  modal: boolean;
  toggle: () => void;
  details: VariableDetailsRecord;
};

const VariableDetails = (props: VariableDetailsProps) => {
  const { modal, toggle, details } = props;
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} charCode="X">
          <span> {details.title.toUpperCase()}</span>
          <Badge color="primary" pill>
            {details.status ? details.status.toUpperCase() : null}
          </Badge>
          <Badge color="primary" pill>
            {details.type.split("_").join(" ").toUpperCase()}
          </Badge>
        </ModalHeader>
        <ModalBody>
          <div>
            <Container fluid>
              <h1 className="display-3">{details.title.toUpperCase()}</h1>
              <Badge color="primary" pill>
                {details.variable_type
                  ? details.variable_type.toUpperCase()
                  : null}
              </Badge>

              {details.variable_complex_type ? (
                <Badge color="primary" pill>
                  {details.variable_complex_type.toUpperCase()}{" "}
                </Badge>
              ) : null}

              <p className="lead">{details.notes}</p>
              <hr className="my-2" />
              <p>{details.example}</p>
              <div style={{ margin: "10px 0" }}>
                {details.image ? (
                  <Media object src={details.image} alt={details.title} />
                ) : (
                  <Badge color="danger" pill>
                    No image found
                  </Badge>
                )}
              </div>
              <small className="text-muted">
                Last updated {formatDateTime(details.updatedAt)}
              </small>
            </Container>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default VariableDetails;
